import { app } from '../../../../app';
import { Controller } from './share.controller';

app.component('companySharingCenterShare', {
    bindings: {
		companyId: '<',
		isNote: '<',
		sharedAccount:'<',
        labels$: '<',
        sharedAccountId: '<',
        users: '<',
        sharedLabels: '<',
        assignedUnassignedFolders: '<',
    },
    controller: Controller,
    templateUrl: require('./share.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/share/share.component.js